import ElementChangedEvent from 'core/utils/events/ElementChangedEvent';
import {
  IconChangedEvent,
  EVENT_ICON,
  HTMLBnumButton,
  LoadingStateChangedEvent,
  IconPropType,
  EVENT_ICON_PROP_CHANGED,
  IconPropChangedEvent,
  VariationChangedEvent,
  EVENT_VARIATION,
  LinkedClickEvent,
} from '../internal';

export function OnIconChangeInitializer(
  event: IconChangedEvent,
  instance: HTMLBnumButton,
) {
  event.push((newValue, oldValue) => {
    instance.dispatchEvent(
      new ElementChangedEvent(EVENT_ICON, newValue, oldValue, instance),
    );
  });
}

export function OnLoadingStateChangeInitializer(
  event: LoadingStateChangedEvent,
  instance: HTMLBnumButton,
) {
  event.push((instance as any)._p_onLoadingChange);
}

export function OnIconPropChangeInitializer(
  event: IconPropChangedEvent,
  instance: HTMLBnumButton,
) {
  event.push((type: IconPropType, newValue: string) => {
    instance.dispatchEvent(
      new CustomEvent(EVENT_ICON_PROP_CHANGED, {
        detail: { type, newValue },
      }),
    );
  });
}

export function OnVariationChangeInitializer(
  event: VariationChangedEvent,
  instance: HTMLBnumButton,
) {
  event.push((newValue, oldValue) => {
    instance.dispatchEvent(
      new ElementChangedEvent(EVENT_VARIATION, newValue, oldValue, instance),
    );
  });
}

export function OnClickInitializer(
  event: LinkedClickEvent,
  instance: HTMLBnumButton,
) {
  instance.addEventListener('click', () => {
    event.call();
  });
}
